/**
 * Pagination and grid display constants
 */

// Default pagination settings
export const DEFAULT_PAGE_SIZE: number = 10;
export const DEFAULT_PAGE_SIZE_SELECTOR: number[] = [10, 20, 50];

// Performance settings
export const DEFAULT_CACHE_BLOCK_SIZE: number = 100; // Set to 100 for optimal flow and performance
